<div id="topbar" class="topbar clearfix">
  <div class="topbar-left">
    <div class="logo"></div>
  </div>
  <div class="topbar-right">
    <a id="menu-button" href="#" (click)="app.onMenuButtonClick($event)">
      <i class="pi pi-chevron-left"></i>
    </a>

    <a
      id="rightpanel-menu-button"
      class="topbar-icon-btn"
      href="javascript:;"
      title="Sair"
      (click)="logout()"
    >
      <i class="pi pi-power-off"></i>
    </a>

    <!-- Dark mode toggle — order:4 via styles.scss -->
    <a
      id="dark-mode-toggle"
      class="topbar-icon-btn"
      href="javascript:;"
      [title]="themeService.darkMode() ? 'Modo claro' : 'Modo escuro'"
      [attr.aria-label]="themeService.darkMode() ? 'Ativar modo claro' : 'Ativar modo escuro'"
      (click)="themeService.toggleDarkMode()"
    >
      <i
        class="pi"
        [class.pi-sun]="themeService.darkMode()"
        [class.pi-moon]="!themeService.darkMode()"
      ></i>
    </a>

    @if (parcelasPendentes().length > 0) {
    <div id="topbar-fatura-btn" class="notif-host">
      <a
        id="rightpanel-menu-button"
        class="topbar-icon-btn btn-boleto notif-anchor"
        href="javascript:;"
        title="Fatura"
        aria-label="Faturas pendentes"
        (click)="toggleFatura($event)"
      >
        <span class="notif-wrap">
          <i class="pi pi-barcode"></i>
          @if (parcelasPendentes().length > 1) {
            <span class="notif-badge" [attr.aria-label]="parcelasPendentes().length + ' faturas pendentes'">
              {{ parcelasPendentes().length }}
            </span>
          }
        </span>

        @if (showFaturaPanel()) {
          <dialog class="notif-panel" open aria-label="Faturas pendentes" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <div class="notif-panel-header">
              <span>Faturas pendentes</span>
              <span class="notif-panel-count">{{ parcelasPendentes().length }}</span>
            </div>
            <ul class="notif-panel-list">
              @for (parcela of parcelasPendentes(); track parcela.bankSlipUrl) {
                <li class="notif-panel-item" [class.notif-sev-error]="estaVencida(parcela)">
                  <button
                    type="button"
                    class="notif-item-btn notif-item-clicavel"
                    (click)="abrirPaginaFatura(parcela)"
                  >
                    <i
                      class="pi notif-panel-icone"
                      [class.pi-exclamation-triangle]="estaVencida(parcela)"
                      [class.pi-barcode]="!estaVencida(parcela)"
                      aria-hidden="true"
                    ></i>
                    <div class="notif-panel-texto">
                      <strong>{{ parcela.value | currency: 'BRL' }}</strong>
                      <span>
                        @if (estaVencida(parcela)) {
                          <span class="notif-tag-vencida">VENCIDA</span> —
                        }
                        Vencimento: {{ parcela.dueDate | date: 'dd/MM/yyyy' }}
                      </span>
                    </div>
                  </button>
                </li>
              }
            </ul>
          </dialog>
        }
      </a>
    </div>
    }

    <!-- Sino de alertas — order:3 via styles.scss -->
    <div id="topbar-notif-btn" class="notif-host">
      <a
        class="topbar-icon-btn notif-anchor"
        href="javascript:;"
        title="Alertas do sistema"
        aria-label="Notificações"
        (click)="togglePanel($event)"
      >
        <span class="notif-wrap">
          <i class="pi pi-bell"></i>
          @if (totalNotificacoes() > 0) {
            <span class="notif-badge" [attr.aria-label]="totalNotificacoes() + ' novas notificações'">
              {{ totalNotificacoes() }}
            </span>
          }
        </span>

        @if (showPanel()) {
          <dialog class="notif-panel" open aria-label="Alertas e notificações" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <div class="notif-panel-header">
              <span>Alertas do sistema</span>
              @if (notificacoes.qtdAlertas() > 0) {
                <span class="notif-panel-count">{{ notificacoes.qtdAlertas() }}</span>
              }
            </div>
            @if (notificacoes.restricoesPendentes().length > 0) {
              <div class="notif-panel-secao">
                <span class="notif-panel-secao-titulo">Solicitações de Liberação</span>
                <ul class="notif-panel-list">
                  @for (restricao of notificacoes.restricoesPendentes(); track restricao.id) {
                    <li class="notif-panel-item notif-sev-warning">
                      <button
                        type="button"
                        class="notif-item-btn notif-item-clicavel"
                        (click)="abrirDialogRestricao(restricao)"
                      >
                        <i class="pi pi-exclamation-triangle notif-panel-icone" aria-hidden="true"></i>
                        <div class="notif-panel-texto">
                          <strong>{{ labelTipoRestricao(restricao.tipo) }}</strong>
                          <span>{{ restricao.solicitante || 'Solicitação pendente' }}</span>
                        </div>
                      </button>
                    </li>
                  }
                </ul>
              </div>
            }
            @if (notificacoes.alertas().length > 0) {
              <ul class="notif-panel-list">
                @for (alerta of notificacoes.alertas(); track alerta.tipo) {
                  <li class="notif-panel-item" [class]="'notif-sev-' + alerta.severidade.toLowerCase()">
                    <i class="pi notif-panel-icone" [class]="iconeAlerta(alerta.severidade)" aria-hidden="true"></i>
                    <div class="notif-panel-texto">
                      <strong>{{ alerta.titulo }}</strong>
                      <span>{{ alerta.descricao }}</span>
                    </div>
                  </li>
                }
              </ul>
            }
            @if (totalNotificacoes() === 0) {
              <p class="notif-panel-empty">
                <i class="pi pi-check-circle"></i> Nenhum alerta no momento.
              </p>
            }
          </dialog>
        }
      </a>
    </div>

    <!-- Welcome label -->
    <span class="topbar-welcome">Bem vindo {{ usuario }}</span>
  </div>
</div>

<!-- Dialog de decisão de liberação (disparado pelo sino) -->
<p-dialog
  [visible]="dialogAberto()"
  (visibleChange)="dialogAberto.set($event)"
  [modal]="true"
  [closable]="true"
  [header]="tituloDialog()"
  [style]="{ width: '480px' }"
>
  <div class="dialog-corpo">
    <label for="observacao-toolbar">Observação</label>
    <textarea
      id="observacao-toolbar"
      class="p-inputtextarea"
      rows="4"
      [value]="observacao()"
      (input)="observacao.set($any($event.target).value)"
    ></textarea>
    <small>Campo opcional. Informe o motivo da decisão se necessário.</small>
  </div>
  <ng-template pTemplate="footer">
    <p-button label="Cancelar" severity="secondary" [text]="true" (onClick)="dialogAberto.set(false)"></p-button>
    <p-button label="Rejeitar" severity="danger" (onClick)="confirmarDecisao('REJEITAR')"></p-button>
    <p-button label="Aprovar" severity="success" (onClick)="confirmarDecisao('APROVAR')"></p-button>
  </ng-template>
</p-dialog>
